/* eslint no-param-reassign: 0 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as ReactTable from 'reactabular-table';
import classNames from 'classnames';
import {
	isUndefined, isFunction, isEmpty, forEach, assign, isEqual, cloneDeep, get,
} from 'lodash';

class CoreTable extends Component {
	shouldComponentUpdate = ({
		columns, data, sortedColumn, rowKey, asc,
	}) => {
		const lastProps = this.props;

		return (
			!isEqual(columns, lastProps.columns)
			|| !isEqual(data, lastProps.data)
			|| !isEqual(sortedColumn, lastProps.sortedColumn)
			|| !isEqual(rowKey, lastProps.rowKey)
			|| !isEqual(asc, lastProps.asc)
		);
	}

	getColumns = () => {
		const {
			columns,
			sortedColumn,
			asc,
		} = cloneDeep(this.props);

		// Add sortable class to each column if there
		// it has a sortable=true property from column definition
		forEach(columns, (column) => {
			const { header } = column;

			if (isUndefined(header) || !header.sortable) return;

			if (isUndefined(header.props)) column.header.props = { className : 'sortable' };
			else {
				const { className } = header.props;
				column.header.props.className = `${isUndefined(className) ? '' : `${className} `}sortable`;
			}

			// Attach the proper callback
			column.header.props.onClick = this.onSortColumn.bind(null, column.property);

			// if there is already defined a sorted column,
			// process the proper column with asc/desc identifier
			if (isUndefined(sortedColumn) || isUndefined(asc) || sortedColumn !== column.property) return;

			let processedClassName = header.props.className;

			processedClassName = classNames(assign({}, this.convertClassStringIntoObject(processedClassName), {
				asc,
				desc : !asc,
			}));

			column.header.props.className = processedClassName;
		});

		return columns;
	}

	onSortColumn = (property, event) => {
		const { onSortColumn } = this.props;

		if (!isUndefined(onSortColumn) && isFunction(onSortColumn)) onSortColumn(property, event);
	}

	convertClassStringIntoObject = (classString) => {
		const headerClassList = {};

		// convert current class list to keyValue object
		classString.split(' ').forEach((value) => {
			headerClassList[value] = true;
		});

		return headerClassList;
	}

	handleRow = (row) => {
		const { onClickRow, isReceiptTable } = this.props;
		if (isFunction(onClickRow)) {
			return {
				onClick : (event) => {
					const dataset = get(event, ['target', 'dataset']);

					if (dataset.clickable) return;

					onClickRow(row);
				},
				className : isReceiptTable ? undefined : 'cursor-pointer',
			};
		}

		return null;
	}

	render() {
		const { className, data, rowKey } = this.props;

		return (
			<ReactTable.Provider
				className={classNames('table', className, { empty : isEmpty(data) })}
				columns={this.getColumns()}
			>
				<ReactTable.Header />
				<ReactTable.Body
					rows={data}
					rowKey={rowKey}
					onRow={this.handleRow}
				/>
			</ReactTable.Provider>
		);
	}
}

CoreTable.propTypes = {
	columns        : PropTypes.array,
	data           : PropTypes.array,
	className      : PropTypes.string,
	sortedColumn   : PropTypes.string,
	rowKey         : PropTypes.string,
	asc            : PropTypes.bool,
	isReceiptTable : PropTypes.bool,
	onSortColumn   : PropTypes.func,
	onClickRow     : PropTypes.func,
};

CoreTable.defaultProps = {
	columns        : [],
	data           : [],
	className      : undefined,
	sortedColumn   : 'Date',
	rowKey         : 'rowId',
	asc            : false,
	isReceiptTable : false,
	onSortColumn   : () => { },
	onClickRow     : () => { },
};

export default CoreTable;
